"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginHistoryActionCreators = exports.LoginHistoryActionTypes = void 0;
var LoginHistoryActionTypes;
(function (LoginHistoryActionTypes) {
    LoginHistoryActionTypes["List"] = "LoginHistory.List";
    LoginHistoryActionTypes["Clear"] = "LoginHistory.Clear";
})(LoginHistoryActionTypes = exports.LoginHistoryActionTypes || (exports.LoginHistoryActionTypes = {}));
class LoginHistoryActionCreators {
}
exports.LoginHistoryActionCreators = LoginHistoryActionCreators;
LoginHistoryActionCreators.list = (loginHistory) => ({
    type: LoginHistoryActionTypes.List,
    loginHistory
});
LoginHistoryActionCreators.clear = () => ({
    type: LoginHistoryActionTypes.Clear
});
//# sourceMappingURL=loginHistory.js.map